import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

export default function GradientCircularProgress() {
    return (
        <React.Fragment>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#f40009" />
                        <stop offset="25%" stopColor="#e5813e" />
                        <stop offset="100%" stopColor="#6ac9ce" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
        </React.Fragment>
    );
}